module.exports = __webpack_public_path__ + "static/media/jc.b16ae6e0.jpg";